import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticVansMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({make, model, sellerTypeId, version}) => {
    const isDefault = !make && !model && !sellerTypeId && !version
    const hasVersion = Boolean(version)

    switch (true) {
      case isDefault:
        return 'default'
      case hasVersion:
        return 'version'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {make, model, province, sellerTypeId, version}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      model,
      province,
      version,
      sellerTypeId
    })

    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
